import { useChatInputStore } from '~/stores/use-chat-input/useChatInput';

export const useIsGeneratedQuestion = (suggestedValue?: string) => {
  const hasUserInteracted = useChatInputStore(state => state.hasUserInteracted);
  return !hasUserInteracted && !!suggestedValue;
};
